module.exports = __webpack_public_path__ + "static/media/bercea.27864823.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/assets/bercea.png
// module id = 446
// module chunks = 0